import { RootStateOrAny, useSelector } from "react-redux";
import { Organization, Role } from "types";

interface UseGetOrganizationsProps {
  organizationId?: string | null;
  slug?: string;
}

const useGetOrgs = ({ organizationId, slug }: UseGetOrganizationsProps) => {
  const organizations = useSelector(
    (state: RootStateOrAny) =>
      state.organizations.organizations as Organization[]
  );

  const roles = useSelector(
    (state: RootStateOrAny) => state.organizations.roles as Role[]
  );

  const specificOrganization =
    organizations?.filter(
      (t: { uuid: string }) => t.uuid === organizationId
    )[0] ||
    organizations?.filter((t: { slug: string }) => t.slug === slug)[0] ||
    null;

  return {
    organizations: organizations || [],
    specificOrganization,
    defaultOrganization: organizations[0]?.slug,
    roles,
  };
};

export default useGetOrgs;
